import { IResourceComponentsProps } from '@refinedev/core';
import { AntdInferencer } from '@refinedev/inferencer/antd';

export const EarnNetworkEdit: React.FC<IResourceComponentsProps> = () => {
  return <AntdInferencer />;
};
